module.exports = __webpack_public_path__ + "static/media/luna.391e6ef6.svg";